import { useDictionary } from './useDictionary';
import type { Document } from '@/shared/types';

const useDocumentsDictionary = () => {
  const {
    data: documentsData,
    isLoading: isDocumentsLoading,
    error: documentsError,
  } = useDictionary<Document[]>({
    dictionaryName: 'documents',
  });

  return {
    documentsData,
    isDocumentsLoading,
    documentsError,
  };
};

export { useDocumentsDictionary };
